import React, {
    createContext,
    useContext,
    type ReactNode
} from "react";
import {AuthContextValue} from "../types/permission";
import useStore from "../Store/useStore";


const AuthContext = createContext<AuthContextValue | null>(null);
export const useAuth = (): AuthContextValue => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("<AuthProvider>");
    return ctx;
};
export const AuthProvider = ({ children }: { children: ReactNode }) => {

    const value: any = useStore();


    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};


